import { Component, OnInit } from '@angular/core';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { AppConfig } from 'src/app/app.config';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import * as moment from 'moment';
import { CampaignsService } from 'src/app/campaigns/campaigns.service';

@Component({
  selector: 'lib-campaigns',
  templateUrl: './campaigns.component.html',
  styleUrls: ['./campaigns.component.css']
})
export class CampaignsComponent implements OnInit {

  campaignList: any[]  = [];
  activeCampaign: any;
  institutionID = 0;
  lang = 'en';
  langSubscription: Subscription;
  institutionSubscription: Subscription;
  campaignText: string = '';
  campaignTitle: string = '';
  buttonText: string = '';
  userAgent: string;
  device: string;

  dateFormat = {
    'en': 'DD/MM/yyyy',
    'de': 'DD.MM.yyyy',
    'fr': 'DD/MM/yyyy',
    'cs': 'DD/MM/yyyy',
    'sk': 'DD/MM/yyyy',
    'es': 'DD/MM/yyyy',
    'nl': 'DD/MM/yyyy',
    'hu': 'DD/MM/yyyy',
    'pt': 'DD/MM/yyyy'
  }

  constructor(
    public layoutService: PHBHPLayoutPackageService,
    private config: AppConfig,
    private sanitizer: DomSanitizer,
    private campaignService: CampaignsService
  ) { }

  ngOnInit(): void {
    this.userAgent = window?.navigator?.userAgent;
    this.institutionID = +localStorage.getItem('selectedInstitution');
    
    this.lang = localStorage.getItem('selectedlanguage');
    if (/Android/.test(this.userAgent) && /Chrome/.test(this.userAgent) && /Mobile Safari/.test(this.userAgent)) {
      this.device = 'mobile';
    } else if (/Android/.test(this.userAgent)) {
      this.device = 'mobile';
    } else {
      this.device = 'desktop';
    }
    this.institutionSubscription = this.layoutService.institutionIDSubject.asObservable().subscribe((res) => {
      this.institutionID = res;
      this.setActiveCampaign();
    });

    this.setActiveCampaign();
  }

  setActiveCampaign(){
    if(!this.institutionID) return;
    this.campaignList = this.config.campaigns;
    const activeCampaigns = this.campaignList?.filter(campaign => {
      // device is necessary when the load is maded from the gettokenprofile
      return (campaign.device == 'web' || campaign.device == 'all') 
                && !campaign.campaignVisibilities || campaign.campaignVisibilities.length === 0 || 
                campaign.campaignVisibilities.some(visibility => 
                          visibility.userId == this.config.userData.userId
                          && visibility.institutionID == this.institutionID 
                          && visibility.visible
                        );

    });
    
    let campaign = activeCampaigns?.[0];
    if(campaign) {
      this.activeCampaign = Object.assign({}, campaign);
      this.activeCampaign.icon = this.sanitizer.bypassSecurityTrustHtml(campaign.campaignType.icon);
      this.activeCampaign.link = this.getCampaignLink(campaign);
      this.translateCampaign();
    }else{
      delete this.activeCampaign;
    }
    
    this.langSubscription = this.layoutService.lang.asObservable().subscribe((changelang) => {
      this.lang = changelang;
      this.translateCampaign();
    });

  }

  translateCampaign() {
    let trl = this.activeCampaign?.campaignTranslations?.find(translation => translation.lang === this.lang);
    this.campaignTitle = trl?.title || this.activeCampaign?.title;
    this.campaignText = trl?.text || this.activeCampaign?.text;
    this.buttonText = trl?.buttonText || this.activeCampaign?.buttonText;
    if(this.activeCampaign?.campaignType?.typeName === 'maintenance') {
      if(this.activeCampaign.date) {
        let date = moment.utc(this.activeCampaign.date).local().format(this.dateFormat[this.lang]);
        this.campaignText = this.campaignText.replace("[Date]", date);
      }
      if(this.activeCampaign.startTime) {
        let startTime = moment.utc(this.activeCampaign.startTime).local().format("HH:mm");
        this.campaignText = this.campaignText.replace("[StartTime]", startTime);
      }
      if(this.activeCampaign.endTime) {
        let endTime = moment.utc(this.activeCampaign.endTime).local().format("HH:mm");
        this.campaignText = this.campaignText.replace("[EndTime]", endTime);
      }
    }
  }

  getCampaignLink(campaign: any) {
    
    let campaignInstitution = campaign.campaignInstitutions?.find(institution => institution.institutionID === this.institutionID);
    let campaignCountry = campaign.campaignCountries?.find(country => country.countryID === this.config.userData.country);
    return campaignInstitution?.buttonLink || campaignCountry?.buttonLink || campaign.buttonLink;
  }

  goToLink(){
    window.open(this.activeCampaign.link, "_blank");
  }

  updateCampaignVisibility() {
    this.layoutService.showLoader = true;
    let visibility = {
                      campaignId: this.activeCampaign.campaignId, 
                      userId: this.config.userData.userId,
                      institutionID: this.institutionID,
                      device: 'web',
                      visible: false,
                      browser: this.userAgent
                    };

    this.campaignService.updateCampaignVisibility(visibility).subscribe((campaigns: any) => {
      localStorage.setItem("campaigns", JSON.stringify(campaigns));
      this.config.campaigns = campaigns;
      this.setActiveCampaign();
      this.layoutService.showLoader = false;
    });
    
  }
}
